import React, { useCallback } from "react";

import Box from "../Box";
import DeltaBadge from "../DeltaBadge";
import styled from "styled-components";
import MrclText from "../marcel/MrclText";
import ProgressBar from "../ProgressBar";
import { useTranslation } from "react-i18next";
import { formatKvalue, getCurrencySuffix } from "../../utils/numberUtils";

type SubTurnoverProps = {
  title: string;
  subTitle?: string;
  value: number;
  target: number;
  rate: number;
  showProgressBar?: boolean;
  objectiveLabel?: string;
};

const CTextCustum = styled(MrclText)<{ $color: string }>`
  font-family: system-ui;
  color: ${(props) => props.$color} !important;
`;
const BoxCustom = styled(Box)<{ gap: string }>`
  gap: ${(props) => props.gap};
  display: flex;
`;
const Text = styled(MrclText)`
  font-family: system-ui;
`;
function SubTurnover({ title, subTitle, value, target, rate, showProgressBar = true, objectiveLabel }: SubTurnoverProps) {
  const diff = value - target;
  const {t} = useTranslation();

  const objectiveSection = useCallback( () =>
        <>
        <ProgressBar target={target} value={value} />
        <Box display={"flex"} alignItems={"center"}>

          {!isNaN(diff) ? (
            <CTextCustum
              $color={diff > 0 ? "#33691E" : "#AA0D11"}
              bold
              tagStyle="caption"
            >
              {`${
                diff > 0
                  ? `+${formatKvalue(diff, "")}`
                  : formatKvalue(diff, "")
              }${getCurrencySuffix(diff)}`}
            </CTextCustum>
          ) : (
            "-"
          )}
          <Text
            tagStyle="caption"
            style={{
              paddingInline: "4px",
            }}
          >
            {t('common.sur_objectif_de')}
          </Text>
          {target && !isNaN(target) ? (
            <Text bold tagStyle="caption">
              {`${formatKvalue(target, "")}
              ${getCurrencySuffix(target)}`}
            </Text>
          ) : (
            "-"
          )}
        </Box>
      </>
,[diff, target,value, t])

  const objectiveText = useCallback( () =>
    <Text tagStyle="caption" style={{ textAlign: 'left' }}>
      {`${objectiveLabel} : `}
      <Text bold tagStyle="caption">
        {`${formatKvalue(target, "")}${getCurrencySuffix(target)}`}
      </Text>
    </Text>
,[objectiveLabel, target])


  return (
    <BoxCustom gap="1rem" flexDirection={"column"} data-testid={"subTurnover"}>
      <Box
        width={"100%"}
        display={"flex"}
        alignSelf={"center"}
        justifyContent={"space-between"}
      >
        <BoxCustom
          gap="4px"
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-start"}
          pt={1}
          style={{ flex: 1, minWidth: 0 }}
        >
          <Text size={"l"} bold tagStyle="h3">
            {`${title}`}
          </Text>
          {subTitle &&  (
            <Text size={"s"} style={{ textAlign: 'left' }}>
              {`${subTitle}`}
            </Text>)}
          <BoxCustom gap="4px" display={"flex"} alignItems={"center"}>
            {!isNaN(rate) ? (
             <DeltaBadge value={rate} />
            ) : (
              "-"
            )}
            <Text tagStyle="caption">{"vs "} {t('commercial.n_1')}</Text>
          </BoxCustom>
        </BoxCustom>
        <Box display={"flex"} alignItems={"center"} style={{ flexShrink: 0, paddingLeft: '8px' }}>
          {value && !isNaN(value) ? (
            <Text bold tagStyle={"h1"}>
              {formatKvalue(value, "")}
              <Text size={"m"}>
                {`${getCurrencySuffix(value)}`}
              </Text>
            </Text>
          ) : (
            "-"
          )}
        </Box>
      </Box>
      <BoxCustom gap="4px" flexDirection={"column"}>
        {!!target && (showProgressBar ? objectiveSection() : objectiveText())}
      </BoxCustom>
    </BoxCustom>
  );
}

export default SubTurnover;
